export default "__VITE_ASSET__CvioIFMH__"